import { render, staticRenderFns } from "./WikiBaseConfig.vue?vue&type=template&id=6f42409b"
import script from "./WikiBaseConfig.vue?vue&type=script&lang=ts"
export * from "./WikiBaseConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports